import Message from 'services/api/Message';
import ackBelongsToEmployee from 'utils/ackBelongsToEmployee';

export const OPEN_DIGITAL_SIGNATURE_READ_MODAL = 'OPEN_DIGITAL_SIGNATURE_READ_MODAL';
export const OPEN_DIGITAL_SIGNATURE_READ_MODAL_FULFILLED =
  'OPEN_DIGITAL_SIGNATURE_READ_MODAL_FULFILLED';
export const OPEN_ACKNOWLEDGMENT_READ_MODAL = 'OPEN_ACKNOWLEDGMENT_READ_MODAL';
export const CLOSE_ACKNOWLEDGMENT_READ_MODAL = 'CLOSE_ACKNOWLEDGMENT_READ_MODAL';

const open = (message, channel, employee, log = false) => {
  const openDigitalSignature =
    message.digitalSignature &&
    !(message.acknowledges || []).some(a => ackBelongsToEmployee(a, employee));
  return openDigitalSignature
    ? {
        type: OPEN_DIGITAL_SIGNATURE_READ_MODAL,
        payload: Message.digitalSignature(message._id),
        meta: { message, employee, channel },
      }
    : {
        type: OPEN_ACKNOWLEDGMENT_READ_MODAL,
        payload: {
          message,
          employee,
          channel,
          log,
        },
      };
};

const close = () => ({
  type: CLOSE_ACKNOWLEDGMENT_READ_MODAL,
});

export default { open, close };
